import {
  fetchGet,
  fetchPost,
  fetchPut,
  toQueryString,
} from "../../../../service/api_client";
import { PurchaseOrderModelV2 } from "../../model/purchase_order_model";
import { POListFilter } from "../models/enums";

export const getPurchaseOrderDetailedListDataRepo = async (
  props: POListFilter
) => {
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/purchase-order/detailed-report`;
  const res = await fetchGet(url + toQueryString(props));
  return res;
};

export const ExportPOListDataRepo = async (props: POListFilter) => {
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/purchase-order/po-export`;
  const res = await fetchGet(url + toQueryString(props));
  return res;
};

export const getPurchaseOrderSummarizedListDataRepo = async (
  props: POListFilter
) => {
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/purchase-order/summarized-report`;
  const res = await fetchGet(url + toQueryString(props));
  return res;
};

export const getPurchaseOrderListDataRepo = async (props: POListFilter) => {
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/purchase-order`;
  const res = await fetchGet(url + toQueryString(props));
  return res;
};

export const createPurchaseOrderRepo = async (data: PurchaseOrderModelV2) => {
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/purchase-order`;

  const res = await fetchPost(url, data);
  return res;
};

export const updatePurchaseOrderRepo = async (data: PurchaseOrderModelV2) => {
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/purchase-order`;

  const res = await fetchPut(url + `/${data.id}`, data);
  return res;
};

export const createRevisedPO = async (data: PurchaseOrderModelV2) => {
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/purchase-order/revised-po`;

  const res = await fetchPost(url, data);
  return res;
};

export interface POClosePreview {
  po_id: string;
  po_no: string;
  mode: "short" | "normal";
  eligible: boolean;
  reasons: string[];
  lines: {
    item_code: string;
    item_name: string;
    project_id: string;
    project_name?: string;
    ordered_qty: number;
    received_qty: number;
    price: number;
    received_value: number;
    balance_value: number;
  }[];
  received_value: number;
  invoiced_amount: number;
  invoice_count: number;
  difference: number;
  paid_amount: number;
  balance_value: number;
  project_credits: { project_id: string; project_name?: string; amount: number }[];
}

export const getPOClosePreviewRepo = async (id: string) => {
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/purchase-order/${id}/short-close/preview`;
  return await fetchGet(url);
};

export const closePORepo = async (id: string, message: string) => {
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/purchase-order/${id}/short-close`;
  return await fetchPost(url, { message });
};

export const saveDraftPurchaseOrderRepo = async (
  // data: FormData
  data: Partial<PurchaseOrderModelV2>
) => {
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/purchase-order`;
  const res = await fetchPost(url + "/save-draft", data);
  return res;
};
